export default class BackController {
  /* @ngInject */
  constructor($element) {
    this.element = $element[0];
  }

  $onInit() {
    this.element.addEventListener('click', this.goBack);
  }

  goBack() {
    window.history.back();
  }

  $onDestroy() {
    this.element.removeEventListener('click', this.goBack);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/back/back.controller.js